/* eslint-disable react/require-default-props */
/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2024 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import {
  ErrorMessageValidator,
  ReactSelectSearch,
  SelectChangeFunction,
  IMobileNumber,
} from "@advapacs/common";
import { OptionTypeBase } from "../../types/common";
import SimpleReactValidator from "simple-react-validator";
import { FormLabel } from "react-bootstrap";

type OnChange = (event: React.ChangeEvent<HTMLInputElement>) => void;

interface MobileNumberSelectProps {
  readOnly?: boolean;
  mobileNumber?: IMobileNumber | null;
  countryCode: Array<OptionTypeBase> | undefined;
  mobileNumberNameField?: string;
  handleSelectChange?: SelectChangeFunction;
  onChange?: OnChange;
  validator?: SimpleReactValidator;
  labelName?: string;
  formLabelStyle?: string;
  mobileNumberInvalidMessage?: string;
  defaultColLable?: number;
  defaultColValue?: number;
  isModal?: boolean;
  showLabel?: string;
  isShowLabelCol?: boolean;
  dBlock?: boolean;
  isDark?: boolean;
}
const MobileNumberSelect: FunctionComponent<MobileNumberSelectProps> = (
  props: MobileNumberSelectProps
) => {
  const {
    readOnly,
    mobileNumber,
    countryCode,
    handleSelectChange,
    onChange,
    validator,
    labelName,
    formLabelStyle,
    mobileNumberInvalidMessage,
    defaultColLable = 3,
    defaultColValue = 5,
    showLabel = "",
    isShowLabelCol = false,
    dBlock = false,
    isDark = false,
    mobileNumberNameField = "mobilePhone",
  } = props;
  const { t } = useTranslation();
  return (
    <>
      <div className={`form-group ${dBlock ? "" : "row"}`}>
        <FormLabel
          className={`${
            formLabelStyle
              ? formLabelStyle
              : `col-form-label col-lg-${defaultColLable}`
          }`}
        >
          {labelName}
        </FormLabel>
        {isShowLabelCol && (
          <FormLabel className="col-lg-2 col-form-label ">
            {showLabel}
          </FormLabel>
        )}

        <div
          className={
            !dBlock
              ? `${formLabelStyle ? "col-lg" : `col-lg-${defaultColValue}`}`
              : ""
          }
        >
          <div className="row">
            <div className="col-lg m-b-sm">
              <ReactSelectSearch
                // @ts-ignore
                options={countryCode}
                // @ts-ignore
                handleSelectChange={handleSelectChange}
                name="countryPrefix"
                value={mobileNumber?.countryCode}
                isSearchable={true}
                isDisabled={readOnly}
                placeholder={t("common:country_code")}
                isDark={isDark}
              />
              {validator && mobileNumber?.countryCode && (
                <ErrorMessageValidator
                  errorMessage={validator.message(
                    t("common:country_code"),
                    mobileNumber?.countryCode, // avoid error when validate
                    "required"
                  )}
                />
              )}
            </div>
            <div className="col-md">
              <input
                type="tel"
                className="form-control"
                onChange={onChange}
                name={mobileNumberNameField}
                id={mobileNumberNameField}
                maxLength={15}
                value={mobileNumber?.mobilePhone}
                disabled={readOnly}
                placeholder={labelName}
              />
              {validator && (
                <ErrorMessageValidator
                  errorMessage={validator.message(
                    mobileNumberInvalidMessage as string,
                    {
                      mobilePhone: `+${mobileNumber?.countryCode?.value}${mobileNumber?.mobilePhone}`,
                      nationalNumber: mobileNumber?.mobilePhone,
                    },
                    "validMobileNumber"
                  )}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNumberSelect;
